<template>
  <v-app>
    <v-main>
      <div class="ma-8">
        <v-btn @click="drawer = true" color="primary">Abrir Modal</v-btn>

        <v-navigation-drawer
          v-model="drawer"
          location="right"
          temporary
        >
          <v-list>
            <v-list-item v-for="item in items" :key="item">
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "TestView",
  data() {
    return {
      drawer: false,
      items: ["Elemento 1", "Elemento 2", "Elemento 3", "Elemento 4", "Elemento 5"],
    };
  },
};
</script>

<style scoped>
.ma-8 {
  margin: 32px;
}
</style>
